import { render } from "./SimpanOrderModal_c.vue?vue&type=template&id=e2f4d0bc&scoped=true"
import script from "./SimpanOrderModal_c.vue?vue&type=script&lang=js"
export * from "./SimpanOrderModal_c.vue?vue&type=script&lang=js"

import "./SimpanOrderModal_c.vue?vue&type=style&index=0&id=e2f4d0bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e2f4d0bc"

export default script